import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {ModalComponent, ModalComponentData} from '../../../../components/modal/modal.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {EntityConfiguration, RequiredResourceType} from '../../entity-manage-button.container.component';

export interface RequiredResource extends ModalComponentData {
  type: RequiredResourceType;
  title: string;
  subtitle: string;
  primaryBtn: string;
  payload: boolean;
  route: string;
  errorMessage: string;
}

export const RequiredResources: RequiredResource[] = [
  {
    type: 'active-clusters',
    title: 'No available active clusters',
    subtitle: `Please create or run at least one cluster in your account in order to create`,
    primaryBtn: 'Create a cluster',
    payload: true,
    route: '/clusters/new',
    errorMessage: 'Navigate to create new cluster page error:'
  },
  {
    type: 'clip-source-records',
    title: 'No available DVR records',
    subtitle: `Please create or run at least one DVR record in your account in order to create`,
    primaryBtn: 'Create a DVR record',
    payload: true,
    route: '/dvr',
    errorMessage: 'Navigate to DVR records page error:'
  }
];

@Component({
  selector: 'app-entity-manage-button',
  templateUrl: './entity-manage-button.component.html',
  styleUrls: ['./entity-manage-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityManageButtonComponent {
  @Input() public configuration: EntityConfiguration | undefined = undefined;
  @Input() public isActiveClustersAvailable: boolean = false;
  @Input() public isClipSourceRecordsAvailable: boolean = false;
  @Output() public clickEmit: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public dialog: MatDialog,
    private readonly router: Router
  ) {
  }

  public onClick(): void {
    const isClusterRequired: boolean = this.configuration.requiredResources
      .includes('active-clusters');
    if (isClusterRequired) {
      if (this.isActiveClustersAvailable === false) {
        this.showNoAvailableResourceModal('active-clusters');
        return;
      }
    }

    const isClipSourceRecordsRequired: boolean = this.configuration.requiredResources
      .includes('clip-source-records');
    if (isClipSourceRecordsRequired) {
      if (this.isClipSourceRecordsAvailable === false) {
        this.showNoAvailableResourceModal('clip-source-records');
        return;
      }
    }

    const configuration: EntityConfiguration = this.configuration;
    const url: string | undefined = configuration.url || undefined;

    if (!url) {
      this.clickEmit.emit();
      return;
    }

    this.router
      .navigate([url])
      .catch(error => console.error(`Navigate to ${url} error:`, error));
  }

  private showNoAvailableResourceModal(type: RequiredResourceType): void {
    const configuration: EntityConfiguration = this.configuration;
    const name: string = configuration.name.toLowerCase();

    const resource: RequiredResource | undefined = RequiredResources
      .find((resource: RequiredResource): boolean => resource.type === type);

    const subtitle: string = `${resource.subtitle} ${name}.`;
    const data: ModalComponentData = {
      title: resource.title,
      subtitle: subtitle,
      primaryBtn: resource.primaryBtn,
      payload: resource.payload
    };

    const dialogRef: MatDialogRef<ModalComponent> = this.dialog
      .open(ModalComponent, {
        width: '400px',
        autoFocus: false,
        data: data
      });

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.router.navigate([resource.route])
            .catch((error: any): void => console.error(resource.errorMessage, error));
        }
      });
  }

}
